import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AppProvider } from './context/AppContext'; // <-- IMPORT THE NEW PROVIDER

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* WRAP THE APP IN THE PROVIDER */}
    <AppProvider>
      <App />
    </AppProvider>
  </React.StrictMode>
);